---
de:
  admin:
    market_prices:
      empty_state: Keine Marktpreisdaten für diese Auswahl.
      errors:
        generic: Marktpreisdaten konnten nicht geladen werden.
      filters:
        date: Datum
        month: Monat
        price_area: Preiszone
        week_label_placeholder: Woche auswählen
        week_start: Woche beginnend
        year: Jahr
      missing_hours:
        caption_clear: Alle {total} erwarteten Stunden vorhanden
        caption_missing: "{missing} von {total} erwarteten Stunden fehlen"
        range_display: "{start} – {end}"
        row_caption:
          one: "{count} fehlende Stunde"
          other: "{count} fehlende Stunden"
        title: Fehlende Stunden
        value_clear: Alles in Ordnung
        value_missing:
          one: "{count} fehlende Stunde"
          other: "{count} fehlende Stunden"
        view_day: Tag anzeigen
      modes:
        day: Tag
        month: Monat
        week: Woche
      summary:
        coverage_caption: "{present} / {total} Stunden vorhanden"
        coverage_label: Abdeckung
        missing_caption_unknown: Fehlende Stunden konnten nicht ermittelt werden.
        missing_label: Fehlende Stunden
        missing_value_unknown: "—"
        price_range: Min {min} · Max {max}
      table:
        elspot_eur: Elspot EUR
        elspot_nok: Elspot NOK
        hour: Stunde
        no_value: "–"
        timestamp: Zeitstempel
      timeline:
        coverage_caption: "{present} von {total} Stunden vorhanden"
        coverage_value: "{percent}% Abdeckung"
        gaps_detected: Lücken erkannt
        missing_caption:
          one: "{count} fehlende Stunde"
          other: "{count} fehlende Stunden"
        prompt_select_day: Wählen Sie einen Tag in der Timeline, um die Stunden anzuzeigen.
        title: Abdeckungsübersicht
      timezone_label: Zeitzone · {timezone}
      title: Marktpreise
